import { FormControl, Validators } from '@angular/forms';

import { Taxes } from '@teem/models/taxes';

export class InputTaxForm {

    public uuid = new FormControl();
    public description = new FormControl('', [Validators.required]);
    public expense_type = new FormControl('', [Validators.required]);
    public expense_date = new FormControl('', [Validators.required]);
    public taxable_amount = new FormControl(null, [Validators.required]);
    public cost = new FormControl(null, [Validators.required, Validators.min(1)]);

    public receipt_number = new FormControl('', [Validators.required, Validators.min(1)]);
    public vat_number = new FormControl('', [Validators.required]);
    public vendor_name = new FormControl('', [Validators.required]);
    public vat_percentage = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]);
    public attachment = new FormControl('');
    public currency = new FormControl();
    public submitted = new FormControl(false);
    public edit = new FormControl(false);

    // This if is just used for to data
    public net_vat_amount_percent = new FormControl(0);

    constructor(input?: Taxes) {
        if (input) {

            if (input.uuid)
                this.uuid.setValue(input.uuid);

            this.description.setValue(input.description);
            this.expense_type.setValue(input.expense_type);
            this.expense_date.setValue(input.expense_date);
            this.cost.setValue(input.cost);
            this.currency.setValue(input.currency);
            this.taxable_amount.setValue(input.taxable_amount);
            this.receipt_number.setValue(input.receipt_number);
            this.vat_number.setValue(input.vat_number);
            this.vendor_name.setValue(input.vendor_name);
            this.vat_percentage.setValue(input.vat_percentage);
            this.net_vat_amount_percent.setValue(input.net_vat_amount_percent);

            if (input.attachment) {
                this.attachment.setValue(input.attachment);
            }
        }
    }
}
